import { regexForm } from 'components/utils/regexForm'
import { validationCPF } from 'components/utils/validationsFN'
import formatter from 'utils/formatter'
import * as yup from 'yup'

export const Schema = (id?: string) =>
    yup
        .object({
            cpf: yup
                .string()
                .required()
                .transform(value => formatter.cpf(value))
                .matches(regexForm.cpf)
                .test({
                    name: 'invalid',
                    test: value => !!value && validationCPF(value as string)
                }),
            contato: yup
                .string()
                .required()
                .transform(value => formatter.contato(value))
                .matches(regexForm.contato),
            nome: yup.string().required().trim(),
            grupo: yup.string(),
            email: yup.string().required().email().trim(),
            utilizaMfa: yup
                .string()
                .required('Utiliza MFA é um campo obrigatório'),
            tipoUsuarioPerfil: yup
                .string()
                .required('Acesso é um campo obrigatório'),
            ...(id ? { nomeUsuario: yup.string().required() } : {}),
            matricula: yup
                .string()
                .max(20, 'Matricula deve ter no máximo 20 caracteres'),
            alocacao: yup
                .string()
                .max(20, 'Unidade de Alocação deve ter no máximo 20 caracteres')
        })
        .required()
